import { AuthenticationService } from 'app/auth/service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { User } from 'app/auth/models';

@Component({
    selector: '[core-menu]',
    templateUrl: './core-menu.component.html',
    styleUrls: ['./core-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CoreMenuComponent implements OnInit {
  currentUser: User | null;
  roles: string[] | string;

  @Input()
  layout = 'vertical';

  @Input()
  menu: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreMenuService: CoreMenuService,
    private _authenticationService: AuthenticationService,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    this.setUserAndRoles();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();
    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.setUserAndRoles();
      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();

      this._changeDetectorRef.markForCheck();
    });
  }

  itHasRoles(itemRole: string[]) {
    if (typeof(this.roles)==='string') {
      return itemRole.includes(this.roles);
    } else {
      return this.roles.some((r) => itemRole.includes(r));
    }
  }

  setUserAndRoles() {
    this._authenticationService.currentUser.subscribe((user) => {
      this.currentUser = user;
      this.roles = this._authenticationService.roles;
      this._changeDetectorRef.markForCheck();
    });
  }
}
